import { type Feature } from 'ol';
import { type Geometry } from 'ol/geom';
import type Map from 'ol/Map';
import type VectorSource from 'ol/source/Vector';
import { type MapGeometryItem } from '../createMapSchema.ts';
import { geoJSONEpsg3857 } from '../mapStyleUtils.ts';

/**
 * Converte gli item geometria persistiti (GeoJSON stringa) in `Feature`
 * OpenLayers, ripristinando `id` e `geometryIndex`. Gli item non convertibili
 * vengono scartati (con log). Sorgente unica usata sia al mount (`initDrawing`)
 * sia al ripristino del valore originale FO (`handleRestore`).
 */
export function convertGeometryItemsToFeatures(
  items: MapGeometryItem[],
): Feature<Geometry>[] {
  return items
    .map(item => {
      try {
        const feature = geoJSONEpsg3857.readFeature(
          item.feature,
        ) as Feature<Geometry>;
        feature.setId(item.id);
        if (item.geometryIndex != null) {
          feature.set('geometryIndex', item.geometryIndex);
        }
        return feature;
      } catch (e) {
        console.error('Errore nella conversione della Feature GeoJSON:', e);
        return null;
      }
    })
    .filter((feature): feature is Feature<Geometry> => feature !== null);
}

/**
 * Centra la vista sull'estensione delle feature presenti nella sorgente.
 * No-op se la mappa non è pronta o la sorgente è vuota.
 */
export function fitViewToFeatures(
  map: Map | null | undefined,
  source: VectorSource,
): void {
  if (!map || source.getFeatures().length === 0) return;
  map.getView().fit(source.getExtent(), {
    padding: [16, 16, 16, 16],
    maxZoom: 19,
  });
}
